import { polygonZkEvm as viemPolygonZkEvm } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const polygonZkEvm = {
  displayName: 'Polygon zkEVM',
  runtime: 'evm',
  viemChain: viemPolygonZkEvm,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'polygon-zkevm' },
    qnStreams: {
      networkKey: 'zkevm-mainnet',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
